import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { calcGatewayCircuitComposeId } from 'utils/functions/payments';
import { updateWithdrawalMethods } from './withdrawal.actions';
import {
  withdrawalDetailsEndpoint,
  withdrawalLastEndpoint,
  withdrawalMethodsEndpoint,
} from './withdrawal.config';
import {
  GetWithdrawalDetailResponse,
  GetWithdrawalLastResponse,
  GetWithdrawalLastResponseItem,
  WithdrawalMethod,
  WithdrawalMethodsResponse,
} from './withdrawal.types';

type WithdrawalState = {
  withdrawalMethods: { [gatewayIdCircuitId: string]: WithdrawalMethod };
  lastWithdrawals: GetWithdrawalLastResponseItem[];
  withdrawalDetail: GetWithdrawalDetailResponse['responseObject'] | null;
};

const initialState: WithdrawalState = {
  withdrawalMethods: {},
  lastWithdrawals: [],
  withdrawalDetail: null,
};

const withdrawalReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(apiRequestSuccess, (state, action) => {
      const { payload } = action;

      if (payload.resourceId === withdrawalMethodsEndpoint) {
        const response: WithdrawalMethodsResponse = payload.response.data;

        const withdrawalMethods = response.responseObject;

        if (!Array.isArray(withdrawalMethods)) return;

        const withdrawalMethodsKeyValueEntries = withdrawalMethods.map(
          (withdrawalMode) => {
            const withdrawalCompositeId = calcGatewayCircuitComposeId(
              withdrawalMode.gatewayId,
              withdrawalMode.circuitId,
            );
            return [withdrawalCompositeId, withdrawalMode];
          },
        );

        state.withdrawalMethods = Object.fromEntries(
          withdrawalMethodsKeyValueEntries,
        );
        return;
      }

      if (payload.resourceId === withdrawalLastEndpoint) {
        const withdrawalLastResponse: GetWithdrawalLastResponse =
          payload.response.data;

        state.lastWithdrawals = withdrawalLastResponse.responseObject;
        return;
      }

      if (payload.resourceId === withdrawalDetailsEndpoint) {
        const withdrawalDetailResponse: GetWithdrawalDetailResponse =
          payload.response.data;

        state.withdrawalDetail = withdrawalDetailResponse.responseObject;
        return;
      }
    })
    // TODO --> CANCELLARE QUANDO SI FIXA DI LA
    .addCase(updateWithdrawalMethods, (state, action) => {
      const withdrawalMethods = action.payload;

      if (!Array.isArray(withdrawalMethods)) {
        console.warn('Withdrawal methods have not been provded');
        return;
      }

      const withdrawalMethodsKeyValueEntries = withdrawalMethods.map(
        (withdrawalMode) => {
          const withdrawalCompositeId = calcGatewayCircuitComposeId(
            withdrawalMode.gatewayId,
            withdrawalMode.circuitId,
          );
          return [withdrawalCompositeId, withdrawalMode];
        },
      );

      state.withdrawalMethods = Object.fromEntries(
        withdrawalMethodsKeyValueEntries,
      );
    }),
);

export default withdrawalReducer;
